import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saVonrRetainabilityCellChartConfig } from '../cellChartConfigs';

interface VonrRetainabilitySaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const VonrRetainabilitySaCell: React.FC<VonrRetainabilitySaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saVonrRetainabilityCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default VonrRetainabilitySaCell;
